import { render, staticRenderFns } from "./NewNavbar.vue?vue&type=template&id=a5cd456c&scoped=true&"
import script from "./NewNavbar.vue?vue&type=script&lang=js&"
export * from "./NewNavbar.vue?vue&type=script&lang=js&"
import style0 from "./NewNavbar.vue?vue&type=style&index=0&id=a5cd456c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cd456c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
